<template>
  <div class="chartElem">
    <div class="row">
      <highcharts class="chart" :options="chartOptions" ></highcharts>
    </div>
  </div>
</template>

<script>
export default {
    name: "MultipleAlerta",
    data: () => ({
      cursos: [
            'Materno',
            'Niño',
            'Adolescente',
            'Joven',
            'Adulto',
            'Adulto Mayor', 
        ],
        titulos: [
            'Cuidado Integral de la Gestante',
            'Cuidado Integral del Niño',
            'Cuidado Integral del Adolescente',
            'Cuidado Integral del Joven',
            'Cuidado Integral del Adulto',
            'Cuidado Integral del Adulto Mayor', 
        ],
        grupos: [
            'NEONATO',
            'MENOR DE 1 AÑO',
            '1 AÑO',
            '2 AÑOS',
            '3 AÑOS',
            '4 AÑOS',
            'DE 5 a 11 AÑOS',
            '36 MESES'
        ],
        width: 1,
        height: 1,
      title: '',
      points: [10, 0, 8, 2, 6, 4, 5, 5],
      chartType: 'Spline',
      seriesColor: '#6fcd98',
      colorInputIsSupported: null,
      animationDuration: 1000,
      updateArgs: [true, true, {duration: 1000}],
      chartOptions: {
        chart: {
            zoomtype: 'xy',
        },
        title: {
          text: 'Avance Acumulado',
          x: -80
        },

        xAxis: {
            categories: [],
            tickmarkPlacement: 'on',
            lineWidth: 0,
            crosshair: true
        },

        yAxis: [{ // Primary yAxis
        labels: {
            format: '{value} %',
        },
        title: {
            text: 'Cobertura',
        },
        opposite: true

    }, { // Secondary yAxis
        gridLineWidth: 0,
        title: {
            text: 'Avance y Meta',
        },
        labels: {
            format: '{value}',
        }

    }],

        plotOptions: {
            column: {
                dataLabels: {
                    enabled: true,
                    color: 'black'
                },
            }
        },
        legend: {
        },

        series: [
        {
        name: 'Meta',
        type: 'column',
        color: 'red',
        yAxis: 1,
        data: [],
        marker: {
            enabled: false
        },
        dashStyle: 'shortdot',
        dataLabels: {
            color:'#e00000',
            enabled: true
        }

    }, {
        name: 'Avance',
        type: 'column',
        color: 'blue',
        yAxis: 1,
        data: [],
        dataLabels: {
            color:'#003da0',
        }
    }, {
        name: 'Cobertura',
        type: 'spline',
        color: 'green',
        data: [],
        tooltip: {
            headerFormat: '<b>{series.name}</b><br/>',
            pointFormat: '{point.category}: {point.y}%'
        },
        dataLabels: {
                enabled: true,
                format: '{point.y} %',
                zIndex: 6,
                allowOverlap: true,
            },
    }],

        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ['viewFullscreen', 'downloadPNG', 'downloadJPEG', 'downloadPDF']
                }
            }
        },

        responsive: {
            rules: [{
                condition: {
                    maxWidth: 400,
                },
                chartOptions: {
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal'
                    },
                    pane: {
                        size: '80%'
                    }
                }
            }]
        }
      },
  }),
  created () {
    this.getMedidas()
    this.getIniciar()
  },
  props: ['serie','numerador','denominador','avance','titulo'],
  watch: {
    title (newValue) {
      this.chartOptions.title.text = newValue
    },
    points (newValue) {
      this.chartOptions.series[0].data = newValue
    },
    chartType (newValue) {
      this.chartOptions.chart.type = newValue.toLowerCase()
    },
    seriesColor (newValue) {
      this.chartOptions.series[0].color = newValue.toLowerCase()
    },
    animationDuration (newValue) {
      this.updateArgs[2].duration = Number(newValue)
    }
  },
  methods: {
    getIniciar() { 
      this.chartOptions.title.text = this.titulo
      //this.chartOptions.chart.width = this.width * 0.7
      //this.chartOptions.chart.height = this.height *0.5
      this.chartOptions.chart.width = window.innerWidth - 100
      this.chartOptions.xAxis.categories = this.serie      
      this.chartOptions.series[0].data = this.denominador
      this.chartOptions.series[1].data = this.numerador
      this.chartOptions.series[2].data = this.avance
    },
    getMedidas(){
        this.width = window.screen.width * window.devicePixelRatio
        this.height = window.screen.height * window.devicePixelRatio
    }
  }
}
</script>
